import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { Store } from '@ngxs/store';
import { FormDirectivesService } from '../../../../shared/directives/dynamic-form-directive/form-directives.service';
import { AppSelectors } from '../../../../store/app/app.selectors';
import { InfoBlockComponent } from '../../../../shared/components/info-card-block/info-block.component';
import { LoaderComponent } from '../../../../shared/components/loader/loader.component';

@Component({
  selector: 'app-profile',
  imports: [AsyncPipe, RouterLink, InfoBlockComponent, LoaderComponent],
  templateUrl: './profile.component.html',
})
export class ProfileComponent {
  readonly store = inject(Store);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly maskService = inject(FormDirectivesService);

  readonly userProfile$ = this.store.select(AppSelectors.userDetails);
}
